import { reservationAxios } from '../../../core/rest/axios';
export async function loadTimeList(activityId, branchId, date) {
    return reservationAxios.get('/casy', { params: { pobockaId: branchId, cinnostId: activityId, datum: date } })
        .then((response) => response.data);
}
